// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"3e8d3136","730":"c099065d","825":"529c7df6","904":"3e8d3136","909":"46d00068"}[chunkId] + ".chunk.css";
};